import React, { FC } from 'react';
import type { ImmutableTrip } from 'src/types/trips/Trips';
import { DISPLAY_DATE_FORMAT_LONG, TIME_12 } from 'src/common/constants';
import Avatar from 'src/common/components/Avatar';
import { useSelector } from 'react-redux';
import dateTimeDurationSelector from 'src/inbox/selectors/dateTimeDuration/dateTimeDuration';
import s from './ChargeBookingDetails.module.scss';

type ChargeBookingDetailsProps = {
  isOwner: boolean;
  trip: ImmutableTrip;
};

const ChargeBookingDetails: FC<ChargeBookingDetailsProps> = ({ isOwner, trip }) => {
  const owner = trip.get('owner').toJS();
  const renter = trip.get('renter').toJS();
  const { tripOnly: { startDateTimeMoment, endDateTimeMoment } } = useSelector(dateTimeDurationSelector(trip.get('pk')));
  const formattedDate = startDateTimeMoment.format(DISPLAY_DATE_FORMAT_LONG);
  const formattedStartTime = startDateTimeMoment.format(TIME_12);
  const formattedEndTime = endDateTimeMoment.format(TIME_12);

  return (
    <div className={s.root}>
      <div className={s.avatars}>
        <Avatar
          size="medium"
          user={{
            photo_url: owner.photo_url,
            has_photo: !!owner.has_photo,
            first_name: owner.first_name,
            last_name: owner.last_name,
          }}
        />
        <Avatar
          size="medium"
          user={{
            photo_url: renter.photo_url,
            has_photo: !!renter.has_photo,
            first_name: renter.first_name,
            last_name: renter.last_name,
          }}
        />
      </div>
      <div className={s.details}>
        <p>{isOwner ? renter.email : `Your booking with ${owner.first_name}`}</p>
        <p className={s.date}>{formattedDate}</p>
        <p>{formattedStartTime} - {formattedEndTime}</p>
      </div>
    </div>
  );
};

export default ChargeBookingDetails;
